require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-frauenkirchen.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-frauenkirchen");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-frauenkirchen!./.cache/json/betreuungseinrichtungen-neusiedl-frauenkirchen.json
// module id = 948
// module chunks = 231608221292675